import React from "react";
import "./TermsConditions.css";


const Terms = () => {
  return (
    <div className="Terms">
    <div className="container mx-auto p-6 max-w-3xl text-gray-800 text-center">
      <h1 className="text-3xl font-bold text-blue-700">Terms and Conditions</h1>

      <p className="mt-4 text-lg">
Welcome to esmaaash.com (the “Website”), owned and operated by Smaaash Entertainment Pvt. Ltd.
(“esmaaash”, “Smaaash”, “we”, “us”, or “our”). These Terms and Conditions (&quot;Terms&quot;) govern your
access to and use of the Website and the services provided through it (collectively, the "Services"). By
accessing or using the Website and Services, you agree to comply with and be bound by these Terms. If
you do not agree with these Terms, please do not use the Website and exit immediately.

<br></br>

<p className="mt-2">
YOUR CONTINUED USE OF THE WEBSITE WILL BE TAKEN AS YOUR ACCEPTANCE OF THE TERMS AND CONDITIONS</p>


<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">1. Definitions</h2>

 
<p className="mt-2">
“Content” refers to all materials available on the Website, including but not limited to text, images, software, animations, graphics, videos, audio files, and other forms of media or information.

“User” means any individual or entity that accesses or uses the Website, whether such access is authorized or unauthorized.

“User Content” encompasses all materials or information posted, submitted, or otherwise made available by users of the Website, including but not limited to text, images, videos, and other content.​
</p>
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">2. Intellectual Property
</h2>

 
<p className="mt-2">
2.1 Ownership and Protection

All Content available on the Website, including but not limited to text, images, graphics, logos,
software, animations, audio files, and video files (collectively referred to as “Content”), is owned
by esmaaash or its licensors. The Content is protected by copyright, trademark, and other
intellectual property laws and agreements. esmaaash and its licensors retain all rights, title, and
interest in and to the Content, including all intellectual property rights therein.


2.2 Limited License
Subject to your compliance with these Terms and Conditions, esmaaash grants you a limited, non-
exclusive, non-transferable, revocable license to access and use the Content solely for personal, non-
commercial purposes. This license does not include the right to:

Copy, reproduce, modify, or create derivative works of the Content;

Distribute, transmit, publicly display, or publicly perform the Content;

Use the Content for any commercial purpose or in any way that competes with the Website or its Services.

Any use of the Content beyond the scope of this license requires prior written permission from esmaaash.
 

2.3 Prohibition of Unauthorized Use
Any unauthorized use of the Website or its Content, including but not limited to copying, reproducing,
modifying, distributing, transmitting, or creating derivative works from any Content without prior written
authorization from esmaaash, is strictly prohibited. Such unauthorized use may violate intellectual

property laws and could result in legal action. esmaaash reserves the right to enforce its intellectual
property rights to the fullest extent permitted by law, including seeking injunctive relief and monetary
damages.


2.4 Feedback and Suggestions
Any feedback, suggestions, or ideas you provide to esmaaash regarding the Website or its Content are
non-confidential and shall become the sole property of esmaaash. esmaaash shall have the right to use,
disclose, reproduce, and exploit such feedback or suggestions without any obligation or compensation to
you.


2.5 Enforcement
esmaaash actively enforces its intellectual property rights and will take appropriate legal action against
any individual or entity that infringes on its rights or otherwise violates these Terms and Conditions.
</p>
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">3. User Content

</h2>

<p className="mt-2">

3.1 Grant of License
By submitting, posting via email, or otherwise making available any content, materials, or
information, you grant esmaaash a perpetual, irrevocable, worldwide, royalty-free, non-exclusive,
fully transferable, and sub licensable license to use, reproduce, modify, adapt, publish, translate,
distribute, display, and perform such User Content, in whole or in part, in connection with the
Website and its Services. This license includes, without limitation, the right to:

Use User Content for promotional, marketing, and advertising purposes;

Incorporate User Content into other works or services;

Make User Content available to third parties through various media, including but not limited to social media, websites, and publications.

​

3.2 Representations and Warranties
By submitting User Content, you represent and warrant that:

You own or have the necessary rights, licenses, and permissions to grant the aforementioned license to esmaaash;

The User Content you provide does not infringe, misappropriate, or violate any intellectual property rights, proprietary rights, or privacy rights of any third party;

The User Content complies with all applicable laws, regulations, and guidelines, and does not contain any unlawful, defamatory, obscene, or offensive material.

​

3.3 Responsibility for User Content
esmaaash does not control, and is not responsible for, any User Content posted or submitted by users.
esmaaash does not endorse or guarantee the accuracy, completeness, or legality of any User Content and
is not liable for any opinions, advice, statements, or other information contained in User Content. All
User Content is the sole responsibility of the user who submitted it.


3.4 Rights to Remove User Content
esmaaash reserves the right, but is not obligated, to review, monitor, and remove any User Content that it

deems, in its sole discretion, to be in violation of these Terms, unlawful, defamatory, infringing, or
otherwise objectionable. esmaaash also reserves the right to terminate or suspend your access to the
Website if you engage in activities that involve the submission of User Content that violates these Terms.
</p>
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">4. Prohibited Activities
</h2>
<p className="mt-2">


You may not use any bots, viruses, or other harmful software to interfere with the Website’s functionality.

You may not attempt to frame or mirror the Website or modify, alter, or obscure any proprietary notices or labels.

Posting defamatory, harmful, or illegal content is prohibited, and esmaaash reserves the right to remove such content and restrict access to the Website as needed.
</p>
​<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">5. Links to Third-Party Websites

</h2>
<p className="mt-2">

The Website may contain links to third-party websites that are not controlled by esmaaash. We are not responsible for the content, privacy policies, or practices of these third-party websites.

Accessing third-party websites is at your own risk, and we disclaim any liability for any damages or issues arising from your use of such websites.
</p>
​<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">6. Disclaimers and Limitation of Liability

</h2>
<p className="mt-2">

 

The Website and Services are provided on an “as-is” basis without warranties of any kind, either express or implied. esmaaash does not warrant the accuracy or completeness of the Content and does not assume any responsibility to update the Website.

esmaaash, its affiliates, officers, directors, employees, and agents are not liable for any damages, including but not limited to, direct, indirect, incidental, consequential, or punitive damages arising from your use of the Website or Services.

This limitation of liability applies even if esmaaash has been advised of the possibility of such damages.</p>

​<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">7. Indemnification

</h2>
<p className="mt-2">


You agree to indemnify and hold esmaaash, its affiliates, officers, directors, employees,
and agents harmless from any claims, liabilities, damages, losses, or expenses, including
reasonable attorneys&#39; fees, arising from your use of the Website or violation of these
Terms.</p>

​<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">8. Governing Law and Dispute Resolution

</h2>
<p className="mt-2">

​

These Terms are governed by the laws of India. Any disputes arising from these Terms or your use of the Website will be subject to the exclusive jurisdiction of the courts located in Mumbai, India.

Alternative Dispute Resolution: Before resorting to litigation, the parties agree to attempt to resolve any disputes through mediation or arbitration, as appropriate.</p>

​<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">9. Termination Clause

</h2>
<p className="mt-2">


eSmaaash reserves the right to terminate or suspend your access to the Website or
Services at its sole discretion, without notice, for any violation of these Terms or for any
other reason.</p>
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">10. Force Majeure

</h2>
<p className="mt-2">


eSmaaash shall not be liable for any failure or delay in providing the Website or Services due to
circumstances beyond its control, including but not limited to natural disasters, war, or
government action.</p>
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">11. No Waiver

</h2>
<p className="mt-2">


No failure or delay by esmaaash in enforcing any provision of these Terms shall constitute a
waiver of that provision or any other rights.</p>

<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">12. Refund and Cancellation Policy

</h2>
<p className="mt-2">
 

Tournaments:
Registration fees for tournaments are non-refundable. These fees are allocated to various aspects
of the tournament, such as pool prizes, operational costs, and other logistical expenses. Once
collected, the funds are utilized to support the event, making refunds impractical in order to maintain
the integrity and financial stability of the tournament. For further details, please refer to our Refund
and Cancellation Policy.


Other Services or Products:
For cancellations of bookings or orders related to other services or products, you may request a
cancellation within 36 hours of the booking or ordering. Refunds for such cancellations will be
processed within 7-10 working days. Please note that the timing of the refund may vary based on your
payment method and processing times.</p>
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">13. Changes to These Terms

</h2>
<p className="mt-2">


eSmaaash reserves the right to modify these Terms at any time. Any changes will be posted on
this page with an updated effective date. Your continued use of the Website following any
changes signifies your acceptance of the revised Terms.</p>


<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">14. Data Protection and Privacy

</h2>
<p className="mt-2">


Your privacy is important to us. For information on how we collect, use, and protect your
personal data, please refer to our Privacy Policy, which is available at esmaaash.com. By using
our Website, you consent to the collection and use of your information as outlined in our Privacy
Policy.</p>

​<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">15. Contact Us
</h2>
<p className="mt-2">


 

For any questions or concerns regarding these Terms, please contact us at: esports@smaaash-entertainment.in

Contact Number: +91 22482 51749

Corporate Office: Metro Avenue G-2, Ground Floor, Andheri-Kurla Road, Next to WEH Metro Station, Andheri (East), Mumbai - 400093, India

​

For grievances or concerns, please contact our Grievance Officer, Nilesh Kapile, directly at:

grievanceofficer@smaaash-entertainment.in 

Contact Number: +91 8657731179</p>

</p>
    </div>
    </div>
  );
};

export default Terms;